import React from "react";
import "./DestinationCard.css";
import { Link } from "react-router-dom";
const DestinationCard = (props) => {
  return (
    <div className="card card-c">
      <img
        src={props.src}
        alt="Dubai"
        className="card__image"
      />
      <div className={props.className}></div>
      <div className="dark"></div>
      <div className="card__content">
        <div className="card__title">
         <h2 className="bn"> {props.title}</h2>
          <p className="duration-des">{props.dur}</p>
        </div>
        <div className="card-mis">
        <p className="nep-car-pric">Starting Price from {props.nepalprice}</p>
        </div>
      <Link to={props.srcq} className="text-decorration"> <button className="card__button">
          <span>Explore Now</span>
          <span className="card__arrow">›</span>
        </button> </Link>
      </div>
    </div>
  );
};

export default DestinationCard;